export default "__VITE_ASSET__BjbjdbYk__"